import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

type IndexParams = {
  json_params: string;
  license: string;
  paging_params: {
    limit: number;
    page: number;
  };
  sort_params: {
    field: string;
    order: Order;
  };
  trend?: 'new' | 'prior';
  trend_period: Period;
};

export const index = async ({ json_params, license, ...params }: IndexParams) =>
  apiClient.get(`/companies/${license}/employees?json_params=${json_params}`, { params });
